import { Route, Routes } from 'react-router-dom';
// import { usePermission } from '@/common/hooks';
import routerConfig from '@/config/router';
import KeepAlive from 'react-activation';

type routerConfigProps = {
  path: string;
  element: any;
  children?: routerConfigProps[];
};

const renderRoute = (routerConfigData: any[]) =>
  routerConfigData.map(({ children, ...routeProps }) => {
    // eslint-disable-next-line react/jsx-props-no-spreading
    if (routeProps.cached) {
      // 如果是详情页，用 path + search 作为 cacheKey
      const isDetailPage = routeProps.isDetail;
      const cacheName = isDetailPage ? `${routeProps.path}` : routeProps.path;

      return (
        <Route
          {...routeProps}
          key={routeProps.path}
          element={
            <KeepAlive cacheKey={routeProps.path} name={cacheName}>
              {routeProps.element}
            </KeepAlive>
          }
        >
          {children && renderRoute(children)}
        </Route>
      );
    }
    return (
      <Route {...routeProps} key={routeProps.path}>
        {children && renderRoute(children)}
      </Route>
    );
  });

export const RenderRoutes = () => {
  return <Routes>{renderRoute(routerConfig)}</Routes>;
};

export default RenderRoutes;
